import React from 'react';
import { Box, Button } from '@99designs/emu';
import { linkTo } from '../../common/linkTo';
import { Layout } from '../Layout';

export function Masquerading() {
    return (
        <Layout title="Masquerading" heading="Masquerading">
            <Box>Login is unavailable while masquerading.</Box>

            <Button href={linkTo.logout()} appearance="primary" width="fill">
                Log out
            </Button>
        </Layout>
    );
}
